import { Link } from "react-router-dom";
import RoomGuideSkeleton from "./skeletons/RoomGuideSkeleton";
import { getListingUrl } from "../../../../../utils/url.utils";

export default function RoomGuide({
    title,
    rooms = [],
    activeId,
    activeRoom,
    onChange,
    loading,
}) {
    if (!rooms.length) return null;

    return (
        <section className="roomguide-section">
            <h2 className="roomguide-title">{title}</h2>

            <div className="tab-scroll-wrapper">
                <div className="roomguide-tabs">
                    {rooms.map((room) => (
                        <button
                            key={room.id}
                            disabled={loading}
                            className={`roomguide-tab ${activeId === room.id ? "active" : ""}`}
                            onClick={() => onChange(room.id)}
                        >
                            {room.name.toUpperCase()}
                        </button>
                    ))}
                </div>
            </div>

            {loading ? (
                <RoomGuideSkeleton />
            ) : (
                activeRoom && (

                    <div className="roomguide-content">
                        <div className="roomguide-image">
                            <img src={activeRoom.media} alt={activeRoom.name} />
                        </div>

                        <div className="roomguide-text">
                            <h3>{activeRoom.name}</h3>
                            <p>{activeRoom.short_description}</p>

                            <h4>Recommendation</h4>

                            <div className="roomguide-recommendations">
                                {activeRoom.size_guide_images?.map((rec, i) => (
                                    <>
                                        <div key={i} className="roomguide-recommendation">
                                            <div className="roomguide-media">
                                                {rec.media_1 && <img src={rec.media_1} alt={rec.name} width={100} />}
                                                {rec.media_2 && <img src={rec.media_2} alt={rec.name} width={100} />}
                                            </div>
                                        </div>
                                        <div>
                                            <h5 className="roomguide-size">{rec.name}</h5>
                                            <p className="roomguide-text-desc">{rec.description}</p>
                                        </div>
                                    </>
                                ))}
                            </div>

                            <Link to={getListingUrl(activeRoom.action_url)}>
                                <button className="roomguide-btn">
                                    {activeRoom.button_styles}
                                </button>
                            </Link>
                        </div>
                    </div>



                )
            )}
        </section>
    );
}
